import React, { useEffect, useRef } from 'react';
import { Users, ChefHat, Wine, Sparkles } from 'lucide-react';
import './MeetTheTeam.css';

const MeetTheTeam = () => {
  const teamRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = teamRef.current?.querySelectorAll('.team-member');
    items?.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const teamMembers = [
    {
      name: 'Kitchen Team',
      role: 'Culinary Experts',
      image: 'https://customer-assets.emergentagent.com/job_2e2e3538-afb2-43be-b0a2-5d03e71fa1dd/artifacts/6fi0lnzt_19493153-AB6A-467B-80FD-808F315E519B.jpeg',
      description: 'Crafting unforgettable flavors in every dish.',
      icon: ChefHat,
      imagePosition: 'top'
    },
    {
      name: 'Bartenders',
      role: 'Mixology Masters',
      image: 'https://customer-assets.emergentagent.com/job_2e2e3538-afb2-43be-b0a2-5d03e71fa1dd/artifacts/21ofoy4w_228E2258-D47F-4571-A12B-ADEC17896B06.png',
      description: 'Mixing signature cocktails with passion.',
      icon: Wine
    }
  ];

  return (
    <section id="team" className="team-section">
      <div className="team-container">
        <div className="team-header section-header-animate">
          <Users size={40} className="team-icon" />
          <h2 className="section-title">Meet the Team</h2>
          <p className="section-subtitle">The people behind your Royal experience</p>
        </div>

        <div className="team-grid" ref={teamRef}>
          {teamMembers.map((member) => {
            const IconComponent = member.icon;
            return (
              <div 
                key={`team-${member.name.toLowerCase().replace(/\s+/g, '-')}`} 
                className="team-member hover-lift"
              >
                <div className="member-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="member-image"
                    style={member.imagePosition === 'top' ? { objectPosition: 'top' } : {}}
                  />
                  <div className="member-icon">
                    <IconComponent size={20} />
                  </div>
                </div>
                <div className="member-info">
                  <h3 className="member-name">{member.name}</h3>
                  <span className="member-role">{member.role}</span>
                  <p className="member-description">{member.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="team-cta">
          <p>Want to join our family?</p>
          <a href="/careers" className="btn-join-team">View Open Positions</a>
        </div>
      </div>
    </section>
  );
};

export default MeetTheTeam;
